var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formDefinition != null)?_c('CollectForm',{attrs:{"formDefinition":_vm.formDefinition,"readonly":_vm.readonly},on:{"submit":_vm.submit}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }